<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="readonly ? '每日稽核单预览' : '每日稽核单填写'"
      class="ipqc-daily-edit"
      width="1250px"
      top="5vh"
      @close="resetData">
    <div v-if="detailVo.pkid">
      <div class="vm-separate">
        <el-form-item label="稽核日期">
          <el-input :value="detailVo.checkDate" disabled/>
        </el-form-item>
        <el-form-item label="来源模板">
          <el-input :value="detailVo.sourceTemplateName || detailVo.templateName" disabled/>
        </el-form-item>
        <el-form-item label="状态">
          <el-tag :type="statusType">{{statusName}}</el-tag>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="线别">
          <el-input v-model.trim="detailVo.lineName" placeholder="请输入线别" clearable :disabled="readonly"/>
        </el-form-item>
        <el-form-item label="IPQC检验员">
          <el-input v-model.trim="detailVo.ipqcName" placeholder="请输入检验员" clearable :disabled="readonly"/>
        </el-form-item>
        <el-form-item label="审核人">
          <el-input v-model.trim="detailVo.auditor" placeholder="请输入审核人" clearable :disabled="readonly"/>
        </el-form-item>
      </div>
      <div v-if="!editable && !readonly" style="color:#e6a23c;margin-bottom: 8px">
        当前时间不在任何可填写时段内,数据已锁定,仅供查看
      </div>
      <el-table :data="detailVo.detailList" border max-height="520" :span-method="spanMethod">
        <el-table-column type="index" align="center" width="55" label="序号"/>
        <el-table-column prop="station" align="center" width="140" label="工位"/>
        <el-table-column prop="checkItem" align="left" minWidth="300" label="检查项目"/>
        <el-table-column v-for="(p, i) in periods" :key="i" align="center" :label="p">
          <template slot-scope="scope">
            <template v-if="!readonly && editable && i === currentIdx">
              <el-select v-model="scope.row[pField(i)]" placeholder="" clearable style="width: 110px">
                <el-option v-for="opt in resultOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
              </el-select>
            </template>
            <template v-else>
              <span :style="resultStyle(scope.row[pField(i)])">
                {{scope.row[pField(i)] || ''}}
              </span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button v-if="!readonly && editable" :loading="submitLoading" type="primary" @click="handleSubmit">保存当前时段</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "IpqcDailyEdit",
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        readonly: false,
        detailVo: {
          pkid: 0,
          checkDate: "",
          lineName: "",
          ipqcName: "",
          auditor: "",
          status: 0,
          templatePkid: null,
          sourceTemplateName: "",
          templateName: "",
          periodText: "",
          detailList: [],
        },
        periods: [],
        currentIdx: -1,
        editable: false,
        resultOptions: [
          { value: "√", label: "√ 合格" },
          { value: "×", label: "× 不合格" },
          { value: "/", label: "/ 不涉及" },
        ],
        // 工位合并: key=行index, value=该行起始工位应占行数(非起始行为0表示隐藏)
        stationSpanMap: {},
      };
    },
    computed: {
      statusName() {
        const map = {0: "未填", 1: "进行中", 2: "已完成"};
        return map[this.detailVo.status] || "";
      },
      statusType() {
        const map = {0: "info", 1: "warning", 2: "success"};
        return map[this.detailVo.status] || "info";
      },
    },
    methods: {
      open(row, readonly) {
        this.readonly = !!readonly;
        this.dialogVisible = true;
        this.detailVo = {
          pkid: row.pkid || 0,
          checkDate: row.checkDate || "",
          lineName: row.lineName || "",
          ipqcName: row.ipqcName || "",
          auditor: row.auditor || "",
          status: row.status || 0,
          templatePkid: row.templatePkid || null,
          sourceTemplateName: row.sourceTemplateName || row.templateName || "",
          templateName: row.templateName || "",
          periodText: row.periodText || "",
          detailList: [],
        };
        if (this.detailVo.pkid) {
          this.getData();
        }
      },
      pField(i) {
        return "p" + (i + 1);
      },
      // 计算相同工位的合并映射(按相邻相同station合并)
      calcStationSpan() {
        const rows = this.detailVo.detailList || [];
        const map = {};
        for (let i = 0; i < rows.length; i++) {
          const station = rows[i].station || "";
          if (i > 0 && (rows[i - 1].station || "") === station) {
            // 延续上一次工位,该行隐藏
            map[i] = 0;
          } else {
            // 新工位起始行,向后统计连续相同station的行数
            let span = 1;
            for (let j = i + 1; j < rows.length; j++) {
              if ((rows[j].station || "") === station) {
                span++;
              } else {
                break;
              }
            }
            map[i] = span;
          }
        }
        this.stationSpanMap = map;
      },
      // el-table 合并工位列(columnIndex=1), 返回 [rowspan, colspan]
      spanMethod({ rowIndex, columnIndex }) {
        if (columnIndex === 1 && this.stationSpanMap) {
          const span = this.stationSpanMap[rowIndex];
          if (span !== undefined) {
            if (span > 0) {
              return { rowspan: span, colspan: 1 };
            }
            return { rowspan: 0, colspan: 0 };
          }
        }
      },
      resultStyle(value) {
        if (value === "×") {
          return "color:#f56c6c;font-weight:bold";
        }
        if (value === "/") {
          return "color:#909399;font-weight:bold";
        }
        return "color:#67c23a;font-weight:bold";
      },
      getData() {
        this.$http.get("basic", `ipqcChecks/${this.detailVo.pkid}`).then((resp) => {
          if (resp.success) {
            this.detailVo = resp.data;
            if (!this.detailVo.detailList) {
              this.detailVo.detailList = [];
            }
            this.calcStationSpan();
            this.buildPeriods();
          }
        });
      },
      buildPeriods() {
        const text = this.detailVo.periodText || "";
        this.periods = text ? text.split("|") : [];
        this.calcCurrent();
      },
      calcCurrent() {
        const now = new Date();
        const hm = `${this.pad(now.getHours())}:${this.pad(now.getMinutes())}`;
        let idx = -1;
        this.periods.forEach((p, i) => {
          const seg = p.split("-");
          if (seg.length === 2 && hm >= seg[0].trim() && hm < seg[1].trim()) {
            idx = i;
          }
        });
        this.currentIdx = idx;
        this.editable = idx >= 0;
      },
      pad(n) {
        return n < 10 ? "0" + n : "" + n;
      },
      resetData() {
        this.detailVo = {
          pkid: 0,
          checkDate: "",
          lineName: "",
          ipqcName: "",
          auditor: "",
          status: 0,
          templatePkid: null,
          sourceTemplateName: "",
          templateName: "",
          periodText: "",
          detailList: [],
        };
        this.periods = [];
        this.currentIdx = -1;
        this.editable = false;
        this.readonly = false;
        this.stationSpanMap = {};
      },
      handleSubmit() {
        this.submitLoading = true;
        this.$http.post("basic", "ipqcChecks/daily/save", this.detailVo).then(() => {
          this.submitLoading = false;
          this.$message.success("保存成功");
          this.$emit("save-success");
          this.dialogVisible = false;
        }).catch(() => {
          this.submitLoading = false;
        });
      },
    },
  };
</script>
